/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MyBoards/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BoardsWelcome from 'DesignSystem/Svgs/BoardsWelcome/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MyBoards({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Boards/Content/No/MyBoards",
  innerRef,
  isActive
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtColorsBrandGreen = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green'
        })
let dtColorsBrandGreen10 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.green_10'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="MyBoards.Horizontal"
  data-view-path={viewPath}
 style={{'--mr-1-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--ml-2-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-3-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
/>
<div
  data-testid="MyBoards.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--ml-2-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-1-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-5-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-6-Z1s6v4R': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-9-Z1s6v4R': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--btrr-10-Z1s6v4R': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bblr-11-Z1s6v4R': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--bbrr-12-Z1s6v4R': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mb-14-Z1s6v4R': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--bw-4-Z1s6v4R': isActive ? "1px" : "1px",'--bs-7-Z1s6v4R': isActive ? "dashed" : "solid",'--bc-8-Z1s6v4R': isActive ? dtColorsBrandGreen : "transparent",'--bc-13-Z1s6v4R': isActive ? dtColorsBrandGreen10 : "transparent"}}
 className={`views-block ${styles.Vertical}`}
>
<BoardsWelcome
  viewPath={`${viewPath}/BoardsWelcome`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 marginRight={dtSpaceS}
 marginLeft={dtSpaceS}
 size="normal"
 textAlign="center"
 text="Boards allow you to create sequential tasks that follows from beginning to completion, passing through different states."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 marginLeft={dtSpaceS}
 size="normal"
 weight="semibold"
 marginTop={dtSpaceXs}
 textAlign="center"
 text="Get Started!"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 marginLeft={dtSpaceS}
 size="normal"
 marginTop={dtSpaceXs}
 textAlign="center"
 text="Drag a board from 'Other Boards'"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 marginLeft={dtSpaceS}
 size="normal"
 marginTop={dtSpaceXs}
 textAlign="center"
 text="or"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceS}
 marginLeft={dtSpaceS}
 size="normal"
 marginTop={dtSpaceXs}
 textAlign="center"
 text="Subscribe to stages in boards, or create a new board."
/>
</div>
{children}
</React.Fragment>)
}